module.exports = __webpack_public_path__ + "static/media/events_06.15a0813d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/JPEG/events_06.jpg
// module id = 5924
// module chunks = 0